import {Injectable} from '@angular/core';
import {default as OneSignalPlugin} from "onesignal-cordova-plugin";
import {Debug} from './onesignal/debug';
import {InAppMessages} from './onesignal/in-app-messages';
import {LiveActivities} from './onesignal/live-activities';
import {Location} from './onesignal/location';
import {Notifications} from './onesignal/notifications';
import {Session} from './onesignal/session';
import {User} from './onesignal/user';
import {PushSubscription} from "./onesignal/push-subscription";

@Injectable()
export class OneSignal {
  constructor(
    readonly Debug: Debug,
    readonly InAppMessages: InAppMessages,
    readonly LiveActivities: LiveActivities,
    readonly Location: Location,
    readonly Notifications: Notifications,
    readonly Session: Session,
    readonly User: User,
  ) {
  }

  /**
   * Initializes the OneSignal SDK. This should be called during startup of the application.
   * @param  {string} appId
   * @returns void
   */
  initialize(appId: string): void {
    OneSignalPlugin.initialize(appId);
  };

  /**
   * Login to OneSignal under the user identified by the [externalId] provided. The act of logging a user into the OneSignal SDK will switch the [user] context to that specific user.
   * @param  {string} externalId
   * @returns void
   */
  login(externalId: string): void {
    OneSignalPlugin.login(externalId);
  }

  /**
   * Logout the user previously logged in via [login]. The [user] property now references a new device-scoped user.
   * @returns void
   */
  logout(): void {
    OneSignalPlugin.logout();
  }

  /**
   * Determines whether a user must consent to privacy prior to their user data being sent up to OneSignal. This should be set to true prior to the invocation of initialization to ensure compliance.
   * @param  {boolean} required
   * @returns void
   */
  setConsentRequired(required: boolean): void {
    OneSignalPlugin.setConsentRequired(required);
  };

  /**
   * Indicates whether privacy consent has been granted. This field is only relevant when the application has opted into data privacy protections.
   * @param  {boolean} granted
   * @returns void
   */
  setConsentGiven(granted: boolean): void {
    OneSignalPlugin.setConsentGiven(granted)
  };
}

export const oneSignalProviders = [
  OneSignal,
  Debug,
  InAppMessages,
  LiveActivities,
  Location,
  Notifications,
  PushSubscription,
  Session,
  User,
];
